import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
}));
